module.exports = __webpack_public_path__ + "media/modals/img3-c9e05739.svg";